var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 3.33333L13.3333 6.55333V14H5.33333V3.33333H10.1133ZM10.6667 2H5.33333C4.6 2 4 2.6 4 3.33333V14C4 14.7333 4.6 15.3333 5.33333 15.3333H13.3333C14.0667 15.3333 14.6667 14.7333 14.6667 14V6L10.6667 2ZM9.33333 10C10.0667 10 10.6667 9.4 10.6667 8.66667C10.6667 7.93333 10.0667 7.33333 9.33333 7.33333C8.6 7.33333 8 7.93333 8 8.66667C8 9.4 8.6 10 9.33333 10ZM12 12.2867C12 11.7467 11.68 11.2667 11.1867 11.0533C10.6021 10.7982 9.97115 10.6665 9.33333 10.6665C8.69552 10.6665 8.06457 10.7982 7.48 11.0533C7.23847 11.1566 7.03262 11.3285 6.88801 11.5478C6.74341 11.7671 6.66644 12.024 6.66667 12.2867V12.6667H12V12.2867Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.a830a33b655f07047a29d8c17ac7405e.svg";
export { ForwardRef as ReactComponent };